


export class BrowserAppEvaluationToolInfo {

  public version = '2024.8.29.2';

  constructor() {
  }

}
